import { css } from "@emotion/react";

export const fullWidthStyle = css`
  width: 100%;
`;
